import SEOMetaInfo from '../constants/SEOMetaInfo';

function generateAllRouteVariants(route) {
  // Remove leading/trailing slashes first
  const trimmed = route.replace(/^\/+|\/+$/g, '');

  const variants = new Set(); // use Set to avoid duplicates

  const leading = ['', '/'];
  const trailing = ['', '/'];

  leading.forEach((l) => {
    trailing.forEach((t) => {
      variants.add(`${l}${trimmed}${t}`);
    });
  });

  return Array.from(variants);
}

export const getSEOMetaInfo = (pathname) => {
  const allVariantPaths = generateAllRouteVariants(pathname);

  for (const path of allVariantPaths) {
    if (SEOMetaInfo[path]) {
      return SEOMetaInfo[path];
    }
  }

  // Fallback to original path
  if (SEOMetaInfo[pathname]) {
    return SEOMetaInfo[pathname];
  }
  return SEOMetaInfo.default;
};
